module.exports = __webpack_public_path__ + "img/TemperaturaBlack.1e98e4cf.svg";